import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'full-footer',
  templateUrl: './full-footer.component.html',
  styleUrls: ['./full-footer.component.scss']
})
export class FullFooterComponent implements OnInit {

  currentyear;

  constructor() { }

  ngOnInit() {
    this.currentyear = new Date().getFullYear();
  }

}
